import "react-quill/dist/quill.snow.css";
import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { cochatActions } from "../../store/slices/cochat_slice/cochat_channels_slice";
import { CallServices, CoreServices } from "../../base/service/apiServices";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { ChatState } from "../../base/models/model";
import { useSelector } from "react-redux";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import { insertnotes } from "../../base/utils";
import { v4 as uuidv4 } from "uuid";
import CustomToolbar from "../chatRightBar/editor/customToolbar";



const Editornotes = ({ editingMessageId, editorContentmsg, onEditorChange, setEditingMessageId }: any) => {
  const [fileData, setFileData] = useState<any>([]);
  const [uploadFile, setUploadFile] = useState<any>([]);
  const quillRef = useRef<ReactQuill>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  // console.log("loginUserCcaasDetail", loginUserCcaasDetail)
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  // const [editorContent, setEditorContent] = useState(editorContentmsg);
  const [plainText, setPlainText] = useState("");
  const notes = useSelector((state: any) => state.chatReducer.currentSession.notes); // Accessing notes from Redux
  // optional, if needed
  const uuid = uuidv4();

  let { currentSession } = chatReducer;

  const [activeButton, setActiveButton] = useState<any>({
    bold: false,
    italic: false,
    strikethrough: false,
    unordered_list: false,
    ordered_list: false,
    activeBtn: ""

  });
  const formats = ["bold", "italic", "strikethrough", "strike", "list", "bullet", "link", "image", "emoji"];

  const [emojiModalVisible, setEmojiModalVisible] = useState(false);

  const toggleEmojiPicker = () => {
    setEmojiModalVisible(!emojiModalVisible);
  };
  const close = () => {
    setEmojiModalVisible(false);
  };
  const dispatch = useDispatcher();
  const handleFileUpload = (event: any) => {
    const formData = new FormData();
    const temp_fileData = []
    for (let file of event.target.files) {
      formData.append("doc", file);
      const filevalue = {
        uid: file?.uid,
        lastModified: file?.lastModified,
        lastModifiedDate: file?.lastModifiedDate,
        name: file?.name,
        size: file?.size,
        type: "file",
        webkitRelativePath: file?.webkitRelativePath,
        fileType: file?.type,
        message: file,
      };
      temp_fileData.push(filevalue)
    }
    setFileData([...temp_fileData]);

    console.log("formdata", formData)
    CallServices.post(formData, "/chat_upload_file").then((res: any) => {
      if (res.data.statusCode === 200) {
        setUploadFile(res.data?.fileList);
      }
    });
  };

  // const handleSelect = (e: any) => {
  //   let temp = value?.replace(/<\/?[^>]+(>|$)/g, "") + e.native;
  //   console.log('handleSelect', keyValue, temp);
  //   handleChange(keyValue, temp);
  // };

  // const addLinkToSelection = () => {
  //   if (quillRef.current) {
  //     const quill = quillRef.current.getEditor();
  //     const range = quill.getSelection();
  //     if (range) {
  //       const text = quill.getText(range.index, range.length);
  //       const linkedText = `<a href="${text}" target="_blank" rel="noopener noreferrer">${text}</a>`;
  //       const newValue = value.replace(text, linkedText);

  //       console.log('newValue', newValue)
  //       handleChange(keyValue, newValue);
  //     }
  //   }
  // };


  // const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const applyFormat = async (type: string) => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const range = quill.getSelection();
    if (!range || range.length === 0) return;

    let formatKey: string = type;
    let formatValue: any = true;

    switch (type) {
      case "bold":
      case "italic":
      case "strikethrough":
        formatKey = type === "strikethrough" ? "strike" : type;
        formatValue = !quill.getFormat(range)[formatKey];
        quill.format(formatKey, formatValue);
        break;

      case "insertUnorderedList":
        formatKey = "list";
        formatValue = quill.getFormat(range)[formatKey] === "bullet" ? false : "bullet";
        quill.format(formatKey, formatValue);
        break;

      case "insertOrderedList":
        formatKey = "list";
        formatValue = quill.getFormat(range)[formatKey] === "ordered" ? false : "ordered";
        quill.format(formatKey, formatValue);
        break;

      case "link":
        const selectedText = quill.getText(range.index, range.length).trim();
        if (!selectedText) return;

        let url = selectedText;
        if (!/^https?:\/\//i.test(url)) {
          url = "https://" + url;
        }
        quill.format("link", url);
        break;

      default:
        return;
    }

    // Update button active state
    setActiveButton((prev: any) => {
      switch (type) {
        case "bold":
          return { ...prev, bold: !prev.bold };
        case "italic":
          return { ...prev, italic: !prev.italic };
        case "strikethrough":
          return { ...prev, strikethrough: !prev.strikethrough };
        case "insertUnorderedList":
          return { ...prev, unordered_list: !prev.unordered_list };
        case "insertOrderedList":
          return { ...prev, ordered_list: !prev.ordered_list };
        case "link":
          return { ...prev, link: true };
        default:
          return prev;
      }
    });
  };



  // const updateActiveButtons = (command: string) => {
  //   setActiveButton((prev: any) => ({
  //     ...prev,
  //     bold: command === 'bold' ? !prev.bold : prev.bold,
  //     italic: command === 'italic' ? !prev.italic : prev.italic,
  //     strikethrough: command === 'strikethrough' ? !prev.strikethrough : prev.strikethrough,
  //     unordered_list: command === 'insertUnorderedList' ? !prev.unordered_list : prev.unordered_list,
  //     ordered_list: command === 'insertOrderedList' ? !prev.ordered_list : prev.ordered_list,
  //   }));
  // };
  const inlineStyleButtons = [
    {
      label: "Bold", style: "bold", icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
          <path d="M9.81524 8.72993C9.8281 8.61733 9.8335 8.50793 9.8335 8.40327C9.8335 8.32953 9.8307 8.2592 9.82684 8.19233C9.82684 8.19153 9.82677 8.19087 9.8267 8.1902C9.82657 8.1884 9.8267 8.18647 9.82657 8.18467C9.81457 7.93713 9.76937 7.7172 9.71984 7.519L9.71517 7.50173C9.4971 6.7472 8.96764 6.14673 8.3079 5.7838C8.16897 5.7068 8.02904 5.6534 7.88924 5.602C8.02224 5.4884 8.14984 5.36633 8.2607 5.22633C8.26137 5.22553 8.26224 5.22487 8.2629 5.22407C8.26344 5.2234 8.2641 5.22293 8.26464 5.22227C8.69277 4.6876 8.89224 4.03493 8.89197 3.394C8.89184 2.36667 8.3831 1.3284 7.40897 0.785467L7.4069 0.784333C6.48744 0.2858 5.46637 0.253067 4.5611 0.25H0.666504C0.390371 0.25 0.166504 0.4738 0.166504 0.75C0.166504 1.02607 0.390371 1.25 0.666504 1.25L1.49224 1.24987V10.7474H0.666504C0.390371 10.7474 0.166504 10.9712 0.166504 11.2474C0.166504 11.5235 0.390371 11.7474 0.666504 11.7474L4.5611 11.7473C5.00237 11.7473 5.59017 11.7477 6.1841 11.7005C6.77984 11.6512 7.37864 11.5635 7.88664 11.3437L7.8887 11.3429C8.9377 10.8805 9.6923 9.91067 9.81424 8.73713C9.81437 8.7358 9.8147 8.73453 9.8149 8.7332C9.81504 8.73207 9.8151 8.73107 9.81524 8.72993ZM4.56124 1.2498C5.4359 1.24673 6.2873 1.30673 6.92537 1.66093C7.5383 1.99733 7.89224 2.68873 7.8921 3.394C7.89184 3.8318 7.7565 4.25893 7.4819 4.6002L7.47844 4.6046C7.3247 4.80107 7.1093 4.9736 6.88184 5.09047L6.8749 5.09407C6.5749 5.25473 6.18757 5.35907 5.69257 5.35933C5.69144 5.35933 5.6905 5.36 5.68937 5.36H2.49244V1.2498H4.56124ZM8.82164 8.6204L8.82084 8.62753C8.7365 9.4348 8.2315 10.0942 7.48404 10.4283C7.1667 10.5698 6.64437 10.6627 6.1049 10.7037C5.5629 10.7469 5.0009 10.7473 4.56124 10.7473H2.49237V6.35993L6.21184 6.3598C6.84704 6.35913 7.3631 6.40147 7.8235 6.65847L7.82537 6.65947C8.27564 6.9072 8.61544 7.30547 8.7513 7.77127C8.7925 7.9376 8.82097 8.08407 8.82797 8.23773L8.82837 8.2454L8.8335 8.40327C8.8335 8.47747 8.82984 8.55073 8.82164 8.6204Z" fill="#505152" />
        </svg>
      )
    },
    {
      label: "Italic", style: "italic", icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
          <path d="M9.25592 0.539062H4.27072C3.99452 0.539062 3.77072 0.762863 3.77072 1.03906C3.77072 1.31513 3.99452 1.53906 4.27072 1.53906H6.28759L2.63132 10.4683H0.743652C0.467452 10.4683 0.243652 10.6921 0.243652 10.9683C0.243652 11.2443 0.467452 11.4683 0.743652 11.4683H5.72885C6.00499 11.4683 6.22885 11.2443 6.22885 10.9683C6.22885 10.6921 6.00499 10.4683 5.72885 10.4683H3.71192L7.36819 1.53906H9.25599C9.53212 1.53906 9.75599 1.31513 9.75599 1.03906C9.75599 0.762863 9.53205 0.539062 9.25592 0.539062Z" fill="#505152" />
        </svg>

      )
    },
    {
      label: "strikethrough", style: "strikethrough", icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
          <path d="M9.45838 7.65685C9.65825 7.97339 9.83311 8.38972 9.81645 8.84759C9.79145 9.73865 9.01705 10.3131 7.71805 10.4299C6.01938 10.5797 3.84605 9.56379 3.82105 9.55545C3.51298 9.40565 3.13825 9.53879 2.98838 9.84699C2.83851 10.155 2.97171 10.5297 3.28811 10.6797C3.37978 10.7211 5.43651 11.6955 7.36005 11.6955C7.51825 11.6955 7.67645 11.6872 7.82638 11.6705C10.1496 11.4623 11.024 10.1049 11.0656 8.89759C11.0822 8.43959 10.9906 8.02319 10.849 7.65685H9.45838Z" fill="#505152" />
          <path d="M13.4366 5.69832C13.2656 5.55439 13.0319 5.55439 12.8159 5.55439H8.72925C8.72218 5.55212 8.71725 5.54665 8.71011 5.54485C8.47145 5.48059 8.21245 5.42779 7.95505 5.37492C7.71071 5.32452 7.46798 5.27572 7.24351 5.21225L7.00771 5.15045C6.41491 4.99512 5.80218 4.83412 5.38418 4.49992C4.98005 4.17712 4.74098 3.70625 4.72751 3.20779C4.71531 2.77192 4.92958 2.33039 5.28371 2.05632C5.66958 1.76112 6.22291 1.64485 6.60678 1.58305C7.56758 1.42772 9.18418 1.79125 9.72571 1.94572C10.0558 2.04005 10.4022 1.84732 10.4974 1.51639C10.5918 1.18459 10.3998 0.838987 10.0685 0.744654C9.97825 0.718654 7.83798 0.117721 6.40591 0.350254C5.89038 0.433187 5.13451 0.598254 4.52258 1.06585C3.84558 1.58872 3.45571 2.40272 3.47925 3.24112C3.50205 4.10799 3.91185 4.92199 4.60431 5.47572C4.64225 5.50599 4.68525 5.52612 4.72431 5.55439H1.18405C0.977112 5.55439 0.734179 5.55439 0.563245 5.69832C0.428379 5.80625 0.338379 5.97725 0.338379 6.16612C0.338379 6.35499 0.419312 6.51699 0.554245 6.63392C0.662179 6.73292 0.806179 6.75999 0.950112 6.76892H1.12105C1.12105 6.76892 1.06705 6.76892 2.88425 6.76892H8.51845C8.52831 6.76932 8.53838 6.77279 8.54818 6.77279C8.55618 6.77279 8.56351 6.76912 8.57151 6.76892H13.0498C13.1936 6.75999 13.3286 6.72379 13.4455 6.63392C13.5805 6.52599 13.6614 6.35499 13.6614 6.16612C13.6614 5.97725 13.5716 5.80632 13.4366 5.69832Z" fill="#505152" />
        </svg>

      )
    },
    {
      label: "OL", style: "insertOrderedList", icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
          <path d="M1.69869 4.9614V4.95393H3.54889C3.87716 4.95393 4.10843 4.70767 4.10843 4.39433C4.10843 4.081 3.88463 3.83487 3.54889 3.83487H3.17583V1.0596C3.17583 0.753733 2.95209 0.5 2.61636 0.5H1.87769C1.59423 0.5 1.32569 0.746267 1.32569 1.0596C1.32569 1.37293 1.59423 1.6192 1.88516 1.6192H2.07169V3.84233H1.69863C1.41516 3.84233 1.13916 4.09607 1.13916 4.4018C1.13916 4.70753 1.40769 4.9614 1.69869 4.9614Z" fill="#505152" />
          <path d="M3.57131 10.3857V10.3932H2.80285L3.60858 9.52018C4.11585 8.96818 4.13078 8.10278 3.63091 7.55812C3.00418 6.84198 1.87764 6.90158 1.33311 7.67005L1.07191 8.03558C0.892845 8.28172 0.952578 8.63245 1.19878 8.81152C1.44498 8.99058 1.79565 8.93078 1.97471 8.68465L2.23584 8.32658C2.37011 8.14012 2.63871 8.12518 2.79538 8.29678C2.91478 8.43112 2.91478 8.63992 2.79538 8.77425L1.12418 10.5648C0.975045 10.7289 0.937712 10.9601 1.02718 11.169C1.11671 11.3705 1.31818 11.5047 1.53444 11.5047H3.57124C3.87704 11.5047 4.13071 11.2586 4.13071 10.9452C4.13071 10.6319 3.88458 10.3857 3.57131 10.3857Z" fill="#505152" />
          <path d="M5.4445 2.26628H12.3655C12.7336 2.26628 13.0322 1.96774 13.0322 1.59961C13.0322 1.23148 12.7336 0.932943 12.3655 0.932943H5.4445C5.07623 0.932943 4.77783 1.23128 4.77783 1.59961C4.77783 1.96794 5.07623 2.26628 5.4445 2.26628Z" fill="#505152" />
          <path d="M12.3655 5.33561H5.4445C5.07623 5.33561 4.77783 5.63395 4.77783 6.00228C4.77783 6.37061 5.07623 6.66895 5.4445 6.66895H12.3655C12.7336 6.66895 13.0322 6.37041 13.0322 6.00228C13.0322 5.63415 12.7336 5.33561 12.3655 5.33561Z" fill="#505152" />
          <path d="M12.3655 9.73828H5.4445C5.07623 9.73828 4.77783 10.0366 4.77783 10.4049C4.77783 10.7733 5.07623 11.0716 5.4445 11.0716H12.3655C12.7336 11.0716 13.0322 10.7731 13.0322 10.4049C13.0322 10.0368 12.7336 9.73828 12.3655 9.73828Z" fill="#505152" />
        </svg>

      )
    },
    {
      label: "UL", style: "insertUnorderedList", icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M1.1447 2.73275C1.76988 2.73275 2.2767 2.22594 2.2767 1.60075C2.2767 0.975564 1.76988 0.46875 1.1447 0.46875C0.519509 0.46875 0.0126953 0.975564 0.0126953 1.60075C0.0126953 2.22594 0.519509 2.73275 1.1447 2.73275Z" fill="#505152" />
          <path d="M1.1447 7.13542C1.76988 7.13542 2.2767 6.6286 2.2767 6.00342C2.2767 5.37823 1.76988 4.87142 1.1447 4.87142C0.519509 4.87142 0.0126953 5.37823 0.0126953 6.00342C0.0126953 6.6286 0.519509 7.13542 1.1447 7.13542Z" fill="#505152" />
          <path d="M1.1447 9.27395C0.519429 9.27395 0.0126953 9.78082 0.0126953 10.4061C0.0126953 11.0313 0.519429 11.5381 1.1447 11.5381C1.76996 11.5381 2.2767 11.0312 2.2767 10.4061C2.2767 9.78095 1.76983 9.27395 1.1447 9.27395Z" fill="#505152" />
          <path d="M4.39996 2.26742H11.321C11.6891 2.26742 11.9876 1.96888 11.9876 1.60075C11.9876 1.23262 11.6891 0.934083 11.321 0.934083H4.39996C4.0317 0.934083 3.7333 1.23242 3.7333 1.60075C3.7333 1.96908 4.0317 2.26742 4.39996 2.26742Z" fill="#505152" />
          <path d="M11.321 5.33675H4.39996C4.0317 5.33675 3.7333 5.63508 3.7333 6.00342C3.7333 6.37175 4.0317 6.67008 4.39996 6.67008H11.321C11.6891 6.67008 11.9876 6.37155 11.9876 6.00342C11.9876 5.63528 11.6891 5.33675 11.321 5.33675Z" fill="#505152" />
          <path d="M11.321 9.73942H4.39996C4.0317 9.73942 3.7333 10.0377 3.7333 10.4061C3.7333 10.7744 4.0317 11.0727 4.39996 11.0727H11.321C11.6891 11.0727 11.9876 10.7742 11.9876 10.4061C11.9876 10.0379 11.6891 9.73942 11.321 9.73942Z" fill="#505152" />
        </svg>

      )
    },
    {
      label: "link", style: "link", icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6.40976 7.11797L5.66309 7.8513C5.74309 8.03797 5.78976 8.21797 5.79643 8.3913C5.81643 8.81797 5.60976 9.09797 5.20976 9.48464C5.1831 9.50463 5.16309 9.5313 5.1431 9.55797L4.4231 10.258C4.0231 10.658 3.72976 10.8513 3.3031 10.8313C2.35643 10.7646 1.1431 9.5313 1.10976 8.59797C1.08976 8.15797 1.2831 7.89797 1.71643 7.4713C1.76976 7.41797 2.09643 7.10464 2.3031 6.89797L2.5031 6.70464C2.8631 6.34464 3.1431 6.14464 3.52976 6.14464H3.6031C3.74976 6.15797 3.9031 6.1913 4.05643 6.25797L4.80976 5.51797C4.4431 5.30464 4.04976 5.17797 3.66976 5.1513C2.70309 5.08463 2.11643 5.67797 1.79643 5.99797L1.60976 6.18463C1.36976 6.41797 1.00309 6.7713 1.00309 6.77797C0.549762 7.2113 0.0697617 7.7513 0.109762 8.63797C0.169762 10.0846 1.77643 11.7246 3.23643 11.8246C3.2831 11.8313 3.32976 11.8313 3.37643 11.8313C4.25643 11.8313 4.81643 11.278 5.1231 10.978L5.90976 10.2113C5.90976 10.2113 5.95643 10.158 5.97643 10.1313C6.4031 9.7113 6.82976 9.18464 6.79643 8.34464C6.7831 7.93797 6.6431 7.51797 6.40976 7.11797Z" fill="#505152" />
          <path d="M8.76976 0.177969C7.80309 0.104635 7.20976 0.711302 6.89643 1.02464L6.76976 1.14464C6.5431 1.3713 6.1031 1.80464 6.09643 1.8113C5.64976 2.24464 5.16976 2.77797 5.20976 3.66464C5.2231 4.03797 5.3431 4.4313 5.5431 4.80464L6.30309 4.06464C6.24309 3.91797 6.20976 3.76464 6.2031 3.62464C6.18976 3.1913 6.38976 2.91797 6.81643 2.50464C6.87643 2.44464 7.26309 2.06464 7.46976 1.86464L7.6031 1.73797C7.9631 1.37797 8.23643 1.1713 8.62976 1.1713C8.64976 1.1713 8.67643 1.17797 8.7031 1.17797C9.64976 1.24464 10.8564 2.47797 10.8964 3.41797C10.9098 3.8513 10.7164 4.11797 10.3098 4.5113C10.2831 4.53797 10.2631 4.56464 10.2431 4.5913L9.5231 5.2913C9.11643 5.6913 8.82976 5.87797 8.4031 5.85797C8.22976 5.84464 8.0431 5.7913 7.85643 5.70464L7.10976 6.43797C7.5031 6.67797 7.92976 6.82464 8.33643 6.85797C8.38309 6.85797 8.42976 6.86464 8.47643 6.86464C9.34976 6.86464 9.91643 6.3113 10.2231 6.00464L11.0098 5.23797C11.0098 5.23797 11.0564 5.1913 11.0764 5.16464C11.5031 4.73797 11.9298 4.2113 11.8898 3.37797C11.8298 1.92464 10.2298 0.284635 8.76976 0.177969Z" fill="#505152" />
          <path d="M3.98303 8.47777C3.85316 8.47777 3.72296 8.42764 3.62496 8.3267C3.43223 8.12944 3.43616 7.81237 3.63409 7.6197L7.68096 3.6731C7.8789 3.48037 8.1953 3.48464 8.38796 3.68224C8.58063 3.87984 8.57676 4.19624 8.37883 4.38924L4.33196 8.33584C4.23496 8.43023 4.10896 8.47777 3.98303 8.47777Z" fill="#505152" />
        </svg>

      )
    },
    // {
    //   label: "Ai", style: "insertUnorderedList", icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    //       <path d="M11.6965 1.64449L10.8377 0.796292C10.6428 0.603825 10.3889 0.507692 10.135 0.507692C9.87702 0.507758 9.61915 0.606958 9.42348 0.805025L1.02575 9.30756C0.637614 9.70049 0.641614 10.3336 1.03455 10.7217L1.89341 11.57C2.08828 11.7625 2.34221 11.8586 2.59608 11.8586C2.85408 11.8586 3.11195 11.7594 3.30761 11.5613L11.7053 3.05876C12.0934 2.66583 12.0895 2.03256 11.6965 1.64449ZM2.59615 10.8585L1.73728 10.0103L7.62928 4.04416L8.49002 4.89109L2.59615 10.8585ZM9.19268 4.17962L8.33195 3.33263L10.1341 1.50783L10.135 1.50776L10.9939 2.35596L9.19268 4.17962Z" fill="#505152" />
    //       <path d="M11.8964 8.85116C11.9609 8.89442 11.9932 8.94782 11.9932 9.01249C11.9932 9.07702 11.9609 9.13103 11.8964 9.17383L10.6055 9.69016L10.0891 10.9811C10.0457 11.0456 9.99235 11.0779 9.92768 11.0779C9.86315 11.0779 9.80928 11.0456 9.76635 10.9811L9.25002 9.69016L7.95908 9.17383C7.89455 9.13103 7.86228 9.07702 7.86228 9.01249C7.86228 8.94782 7.89461 8.89442 7.95908 8.85116L9.25002 8.33469L9.76635 7.04376C9.80928 6.97923 9.86315 6.94709 9.92768 6.94709C9.99235 6.94709 10.0457 6.97929 10.0891 7.04376L10.6055 8.33469L11.8964 8.85116Z" fill="#505152" />
    //       <path d="M4.04048 3.11376C4.10501 3.15702 4.13728 3.21043 4.13728 3.27509C4.13728 3.33963 4.10495 3.39363 4.04048 3.43642L2.74955 3.95276L2.23321 5.24369C2.18981 5.30823 2.13641 5.34049 2.07175 5.34049C2.00721 5.34049 1.95335 5.30816 1.91041 5.24369L1.39408 3.95276L0.103148 3.43642C0.0386143 3.39363 0.00634766 3.33963 0.00634766 3.27509C0.00634766 3.21043 0.038681 3.15702 0.103148 3.11376L1.39408 2.59729L1.91041 1.30636C1.95335 1.24182 2.00721 1.20969 2.07175 1.20969C2.13641 1.20969 2.18981 1.24189 2.23321 1.30636L2.74955 2.59729L4.04048 3.11376Z" fill="#505152" />
    //       <path d="M7.23008 1.39609C7.27261 1.42463 7.29395 1.45982 7.29395 1.50249C7.29395 1.54502 7.27261 1.58063 7.23008 1.60889L6.37888 1.94936L6.03841 2.80056C6.00981 2.84309 5.97455 2.86443 5.93195 2.86443C5.88942 2.86443 5.85388 2.84309 5.82555 2.80056L5.48508 1.94936L4.63388 1.60889C4.59135 1.58069 4.57001 1.54502 4.57001 1.50249C4.57001 1.45989 4.59135 1.42463 4.63388 1.39609L5.48508 1.05556L5.82555 0.204358C5.85388 0.161825 5.88942 0.140625 5.93195 0.140625C5.97455 0.140625 6.00981 0.161825 6.03841 0.204358L6.37888 1.05556L7.23008 1.39609Z" fill="#505152" />
    //     </svg>

    //   )
    // },
  ];
  const sendNotes = () => {

    // onEditorChange(""); // Clear editor
    try {
      // console.log('aasasasasasasasasasa', data)

      if (!editingMessageId) {
        let historyId =
          currentSession?.channelType === "Email"
            ? currentSession?.EmailHistoryId
            : currentSession?.channelType === "Sms"
              ? currentSession?.SMSHistoryId
              : (currentSession?.channelType === "Chat" || currentSession?.ChatHistoryId)
                ? currentSession?.ChatHistoryId
                : currentSession?.channelType === "Call"
                  ? currentSession?.CallHistoryId
                  : currentSession?.channelType === "Instagram"
                    ? currentSession?.InstagramHistoryId
                    : currentSession?.channelType === "Facebook"
                      ? currentSession?.FacebookHistoryId
                      : currentSession?.channelType === "Whatsapp"
                        ? currentSession?.WhatsappHistoryId
                        : null;
        let data = {
          noteId: uuid,
          domainId: loginUserCcaasDetail?.domainId,
          historyId: historyId,
          coid: currentSession?.calledPersonDetails?.coid,
          channelType: currentSession?.channelType,
          agentId: loginUserCcaasDetail?.UserID,
          message: editorContentmsg,
          timestamp: new Date().toISOString(),
          userName: loginUserCcaasDetail?.UserName

        };
        dispatch(ChatActions.setNotes(data))
      } else {
        const indexnotes: number = notes?.findIndex((note: any) => note?.noteId === editingMessageId);
        if (indexnotes !== -1) {
          const updatedNote = {
            ...notes[indexnotes],
            message: editorContentmsg
          };
          const updatedNotes = [...notes];
          updatedNotes.splice(indexnotes, 1, updatedNote);
          dispatch(ChatActions.setReplaceNotes(updatedNotes));
        }
      }
      setEditingMessageId(null);
      onEditorChange("")
    } catch (error) {
      console.log('sendNotes>>>>>', error);
    }
  }
  const handleChange = (content: string) => {
    onEditorChange(content); // this must remain as HTML

    if (typeof onEditorChange === "function") {
      onEditorChange(content); // only call if it's actually passed
    }

    const text = quillRef.current?.getEditor().getText().trim();
    setPlainText(text || "");

  };
  // console.log('aasasasasasasasasasa', editorContentmsg)
  const toolbarId = `toolbar-919191`;
  const modules = { toolbar: { container: `#${toolbarId}` } };

  return (
    <>
      <div className="text-editor commoneditorcon chateditornewcon editornotes">
        <ReactQuill
          ref={quillRef}
          value={editorContentmsg} // must be HTML
          className="customtexteditor quillchatmsg"
          onChange={handleChange}
          modules={modules}
          placeholder="Type your Notes here..."
        />
        <div id="toolbar" className="toolbaricon">
          <div className="leftside">
            {/* <span>
              <button className="ql-emoji">
                <span className="iconopen" onClick={() => toggleEmojiPicker()}>
                </span>
                {emojiModalVisible && (
                  <div className="emojipicker">
                    <Picker data={data} onEmojiSelect={handleSelect} onLeave={close} />
                  </div>
                )}
              </button>
            </span> */}
            {editorContentmsg != "smsMessage" && <div>

              {(
                <>
                 <CustomToolbar id={toolbarId}/>

                {/* <span> {inlineStyleButtons.map((button) => {
                  return(
                  <button
                    key={button.style}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => applyFormat(button.style)}
                    // style={{ color: [button.style] ? "blue" : "grey", background: "transparent" }}
                    // className='activebtntrant applybtnicon'
                    className={`${activeButton[button.style] ? "activebtntrant" : "applybtnicon"}`}
                  >
                    {button.icon}
                  </button>
                )})}</span> */}
                  </>
              )}
            </div>}

          </div>
          <div className="rightside rightsidenotesbtn">
            <button
              disabled={!editorContentmsg || editorContentmsg.trim() === "" || editorContentmsg === "<p><br></p>"}
              onClick={() => {
                sendNotes();
              }}>Add</button>
          </div>
        </div>
      </div>
    </>
  );
};
export default Editornotes;
